import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import {
  Box,
  ButtonBase,
  Grid,
  Theme,
  Typography,
  createStyles,
  makeStyles,
} from '@material-ui/core';

import { ReactComponent as RightIcon } from '../../../assets/img/icon/Right.svg';
import MisDenunciasIcon from '../../../assets/img/sinister/my_sinisters.svg';
import DenunciarSiniestro from '../../../assets/img/sinister/report_sinister.svg';
// import MisDenunciasIcon from '../../../assets/img/misDenuncias.svg';
// import DenunciarSiniestro from '../../../assets/img/sinister.svg';
import SubHeader from '../../../components/Header/SubHeader.component';
import SuraCard from '../../../components/SuraCard';

const CARDS = [
  {
    link: '/sinister',
    title: 'Denunciar un siniestro',
    content: 'Seleccioná una póliza para comenzar',
    image: DenunciarSiniestro,
  },
  {
    link: '/account/incidents',
    title: 'Mis denuncias',
    content: 'Accedé al estado de tus denuncias',
    image: MisDenunciasIcon,
  },
];

const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    label: {
      color: '#FEE0CC',
    },
    subLabel: {
      color: '#393B3D',
      fontWeight: 500,
    },
    contactBoxes: {
      marginRight: '70px',
      marginBottom: '12px',
    },
    suraCard: {
      display: 'grid',
      minHeight: '80px',
      [theme.breakpoints.up('sm')]: {
        minHeight: '100px',
      },
    },
    title: {
      color: '#000',
      fontWeight: 500,
      fontSize: '20px',
      marginBottom: '8px',
      [theme.breakpoints.down('xs')]: {
        fontSize: '16px',
      },
    },
    description: {
      color: '#A84308',
      fontWeight: 400,
      fontSize: '16px',
    },
  })
);

const MainClaims = () => {
  const classes = useStyle();

  return (
    <>
      <SubHeader
        content={
          <Box>
            <Typography variant="h6"> Siniestros </Typography>
          </Box>
        }
      ></SubHeader>

      <Box my={3}>
        <Grid container justify="center">
          <Grid item xs={11}>
            <Grid container>
              {CARDS.map((card: any, index: number) => (
                <Grid item xs={12} sm={6} key={index.toString()}>
                  <Box my={3} mr={3} /* onClick={() => cardTag(card)} */>
                    <ButtonBase
                      component={RouterLink}
                      to={card.link}
                      //onClick={() => handlePush(card.title, card.link)}
                      style={{ width: '100%' }}
                    >
                      <SuraCard className={classes.suraCard}>
                        <Box
                          m={1}
                          marginLeft="16px"
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <Box>
                              {' '}
                              <img src={card.image} alt={card.title}></img>{' '}
                            </Box>
                            <Box ml={3}>
                              <Typography className={classes.title}>
                                {' '}
                                {card.title}{' '}
                              </Typography>
                              <Typography className={classes.description}>
                                {' '}
                                {card.content}{' '}
                              </Typography>
                            </Box>
                          </Box>
                          <Box>
                            <RightIcon></RightIcon>
                          </Box>
                        </Box>
                      </SuraCard>
                    </ButtonBase>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default MainClaims;
